'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgLock(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M4.491 14h7.018c.997 0 1.491-.483 1.491-1.548V8.264c0-.939-.393-1.431-1.199-1.52v-.727C11.801 3.27 9.898 2 7.995 2 6.102 2 4.2 3.27 4.2 6.017v.753C3.449 6.896 3 7.38 3 8.264v4.188C3 13.517 3.494 14 4.491 14zM6 6.214C6 4.769 6.913 4 7.996 4S10 4.77 10 6.214v.777L6 7v-.786z", fill: "currentColor" }))));
}

module.exports = SvgLock;
//# sourceMappingURL=Lock.js.map
